// removed by extract-text-webpack-plugin
module.exports = {"header":"_2m9dqKWO5 _17qxy1jyE _3lHRe10pm _1areXnYcM _2OB3nmlqn","content":"_3vppffLUT _17qxy1jyE FVmsZrNVi _38fsqHPnh _1vgzIe30_ _2l0xl0HVf _1yezin6E0 _2WOtyNnnu _2RQ0l3f5Q _3OSOixPVa"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/header/header.css
 ** module id = 2135
 ** module chunks = 0
 **/